import PropTypes from "prop-types";
import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useICCCColors } from "../components/theme";
import { categoryMeta } from "../model/constants";

// Devices at this location with no stored coordinates yet — drag one onto the
// canvas to set its initial position (first-time placement). Rendered as the
// "Unplaced" tab body inside DevicePanel — no outer card wrapper of its own.
export default function UnplacedDevicesPanel({ devices }) {
  const ICCC_COLORS = useICCCColors();

  if (!devices.length) {
    return (
      <MDTypography variant="caption" sx={{ color: ICCC_COLORS.textMuted, display: "block" }}>
        Every device at this location already has a saved position.
      </MDTypography>
    );
  }

  return (
    <MDBox>
      <MDTypography variant="caption" sx={{ color: ICCC_COLORS.textMuted, display: "block", mb: 1 }}>
        Drag a device onto the map to place it.
      </MDTypography>
      {devices.map((d) => {
        const meta = categoryMeta(d.category);
        return (
          <MDBox
            key={d.id}
            draggable
            onDragStart={(e) => e.dataTransfer.setData("text/plain", String(d.id))}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: 0.75,
              mb: 0.5,
              borderRadius: 1,
              cursor: "grab",
              bgcolor: ICCC_COLORS.cardBg2,
              "&:hover": { bgcolor: ICCC_COLORS.hoverBg },
            }}
          >
            <Icon sx={{ color: ICCC_COLORS[d.health] || ICCC_COLORS.unknown, fontSize: 18 }}>{meta.icon}</Icon>
            <MDTypography
              variant="caption"
              sx={{
                color: ICCC_COLORS.textSecondary,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {d.nodeName || `Asset #${d.id}`}
            </MDTypography>
          </MDBox>
        );
      })}
    </MDBox>
  );
}

UnplacedDevicesPanel.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.object).isRequired,
};
